import { AliasLabel } from 'features/store/pages/delivery-store-selector/types';

import { MarkerTypes } from './types';

export const ALIAS_MARKER_MAP: Record<AliasLabel, MarkerTypes> = {
  [AliasLabel.Home]: MarkerTypes.Destination,
  [AliasLabel.Work]: MarkerTypes.DeliveryWork,
  [AliasLabel.Other]: MarkerTypes.DeliveryLocation,
};
